/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ConfirmationControllerStartResetPassword$Params {
  id: string;
  lang: string;
}

export function confirmationControllerStartResetPassword(http: HttpClient, rootUrl: string, params: ConfirmationControllerStartResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, confirmationControllerStartResetPassword.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

confirmationControllerStartResetPassword.PATH = '/confirmation/passwordReset/{id}';
